import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Copy } from "lucide-react";

export default function AccountVouchers() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/api/redemptions").then((r) => setItems(r.data.redemptions || []));
    }, []);

    return (
        <div>
            <h1 className="font-display text-2xl md:text-3xl font-bold">My Vouchers</h1>
            <p className="text-[#6b7280] text-sm">{items.length} total</p>

            <div className="grid md:grid-cols-2 gap-3 mt-5">
                {items.length === 0 && (
                    <div className="md:col-span-2 fx-card p-10 text-center text-[#6b7280]">
                        You don't have any vouchers yet. Browse deals to redeem your points.
                    </div>
                )}
                {items.map((r) => (
                    <div key={r.id} className="fx-card p-5">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="font-semibold">{r.brand_name}</p>
                                <p className="text-[11px] text-[#6b7280]">{r.reward_name}</p>
                            </div>
                            <span
                                className={`fx-chip ${
                                    r.status === "issued"
                                        ? "bg-[#c9a959]/15 text-[#c9a959] border border-[#c9a959]/30"
                                        : "bg-[#f9fafb] text-[#6b7280] border border-[rgba(11,20,55,0.10)]"
                                }`}
                            >
                                {r.status}
                            </span>
                        </div>
                        <p className="font-display text-3xl font-extrabold mt-2">₹{r.denomination}</p>
                        {r.status === "issued" && r.voucher_code && (
                            <div className="grid grid-cols-2 gap-3 mt-3">
                                <CopyField label="Code" value={r.voucher_code} />
                                <CopyField label="PIN" value={r.voucher_pin} />
                            </div>
                        )}
                        <p className="text-[11px] text-[#9ca3af] mt-3">
                            {new Date(r.created_at).toLocaleString("en-IN")} • {r.points_used} pts + ₹{r.cash_paid_paise / 100}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

function CopyField({ label, value }) {
    const [c, setC] = useState(false);
    const copy = () => {
        navigator.clipboard.writeText(value);
        setC(true);
        setTimeout(() => setC(false), 1500);
    };
    return (
        <button
            onClick={copy}
            className="text-left fx-glass rounded-xl p-3 hover:border-[#c9a959]/40 transition-colors"
        >
            <p className="text-[10px] uppercase tracking-widest text-[#6b7280]">{label}</p>
            <div className="flex items-center justify-between mt-0.5">
                <p className="font-mono font-bold tracking-wider">{value}</p>
                <Copy size={12} className={c ? "text-[#c9a959]" : "text-[#9ca3af]"} />
            </div>
        </button>
    );
}
